import { BaseComponent } from '../../types';

interface MockCardProps extends BaseComponent {
  badgeColor: 'green' | 'blue' | 'amber';
}

const badgeColors = {
  green: {
    fill: '#10B981',
    filterId: 'filter0_d_959_7342',
  },
  blue: {
    fill: '#3B82F6',
    filterId: 'filter0_d_959_7353',
  },
  amber: {
    fill: '#F59E0B',
    filterId: 'filter0_d_959_7364',
  },
};

const filterDefinitions = {
  filter0_d_959_7342: '0.0627451 0 0 0 0.72549 0 0 0 0.505882 0 0 0 0.6 0',
  filter0_d_959_7353: '0.231373 0 0 0 0.509804 0 0 0 0.964706 0 0 0 0.6 0',
  filter0_d_959_7364: '0.960784 0 0 0 0.619608 0 0 0 0.0431373 0 0 0 0.6 0',
};

export function MockCard({ className, badgeColor }: MockCardProps) {
  const badge = badgeColors[badgeColor];

  return (
    <div
      className={`grid w-[21rem] md:w-96 h-[70px] md:h-[94px] p-3 md:p-4 md:pt-6 gap-2 md:gap-4 rounded-xl md:rounded-2xl items-center ${className || ''}`}
      style={{
        gridTemplateRows: '45px',
        gridTemplateColumns: '45px minmax(0,1fr) 60px',
        border: '1px solid rgba(148, 163, 184, 0.10)',
        background: 'rgba(51, 65, 85, 0.30)',
        backdropFilter: 'blur(5px)',
      }}
    >
      {/* Sol - Ürün İkonu */}
      <img
        src="/icons/mock-product-image.svg"
        alt="Product"
        className="w-full h-full object-contain"
      />

      {/* Orta - Text Content */}
      <div className="flex flex-col justify-center items-start gap-2 h-full">
        <div
          className="w-[142px] h-3 rounded-md"
          style={{
            background:
              'linear-gradient(90deg, rgba(148, 163, 184, 0.25) 0%, rgba(148, 163, 184, 0.05) 100%)',
          }}
        />

        <div
          className="w-[107px] h-2 rounded-sm opacity-70"
          style={{
            background:
              'linear-gradient(90deg, rgba(148, 163, 184, 0.25) 0%, rgba(148, 163, 184, 0.05) 100%)',
          }}
        />
      </div>

      {/* Sağ - Status Badge */}
      <div className="flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="28"
          viewBox="0 0 80 28"
          fill="none"
        >
          <rect
            width="80"
            height="28"
            rx="14"
            fill={badge.fill}
            fillOpacity="0.15"
          />
          <rect
            x="0.5"
            y="0.5"
            width="79"
            height="27"
            rx="13.5"
            stroke={badge.fill}
            strokeOpacity="0.3"
          />
          <g filter={`url(#${badge.filterId})`}>
            <rect x="13" y="10" width="8" height="8" rx="4" fill={badge.fill} />
          </g>
          <defs>
            <filter
              id={badge.filterId}
              x="5"
              y="2"
              width="24"
              height="24"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="4" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values={`0 0 0 0 ${filterDefinitions[badge.filterId as keyof typeof filterDefinitions]}`}
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
}
